import React, { useEffect } from 'react';
import Loading from '../../../Loading';
import events from '../../../../events';
import { locales } from '../../../../translations/locales';

const VehicleModels = (props) => {
    const { theme, locale, data, setActivePage, ModuleRP } = props;

    useEffect(() => {
        if (data.type !== 'game') {
            ModuleRP.socket.emit(events.CONFIGURE, ModuleRP.gameId);
        }
    }, [data]);

    return (
        data.type === 'game' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">
                        {locales[locale].config.vehicleModels}
                    </h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                            <thead>
                                <tr>
                                    <th>{locales[locale].gamesTable.gameNames}</th>
                                    <th>{locales[locale].config.functions}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.vehicleModels && data.vehicleModels.map((vehicleModel) =>
                                    (<tr key={vehicleModel.id}>
                                        <td>{vehicleModel.name}</td>
                                        <td>
                                            {
                                                vehicleModel.functions.map((vehicleFunction) => (
                                                    <span key={vehicleFunction.name} className='badge badge-primary p-1 m-1'>
                                                        {vehicleFunction.name}
                                                    </span>
                                                ))
                                            }
                                            {
                                                vehicleModel.functions.length === 0 ?
                                                    <span className='badge badge-warning p-1 m-1'>
                                                        {locales[locale].config.needUpdate}
                                                    </span> : ''
                                            }
                                        </td>
                                        <td>
                                            <button
                                                className='btn btn-sm btn-primary float-right'
                                                id='btn-manageVehicleModel'
                                                onClick={() => {
                                                    ModuleRP.config.manageVehicleModel(vehicleModel.id);
                                                    setActivePage('ManageVehicleModel');
                                                }}
                                            >
                                                {locales[locale].config.manage}
                                            </button>
                                        </td>
                                    </tr>
                                    ))
                                }
                                {
                                    data.vehicleModels && data.vehicleModels.length === 0 ?
                                        <tr>
                                            <td colSpan={3}>
                                                {locales[locale].config.noVehicleModel}
                                            </td>
                                        </tr> :
                                        <tr></tr>
                                }
                                <tr>
                                    <td colSpan={3}>
                                        <button
                                            className='btn btn-sm btn-primary'
                                            onClick={() => setActivePage('NewVehicleModel')}
                                        >{locales[locale].config.addNewVehicleModel}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default VehicleModels;
